import React from 'react';
import MinimalWheel from './MinimalWheel';
import './GameView.css';

const GameView = () => {
  return (
    <div className="game-view">
      <MinimalWheel />
    </div>
  );
};

export default GameView;

